import AcademyComponent from "../../components/academy";
import Fragment from "../../../toolkit/fragment";
import get from "lodash.get";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import NotFoundPage from "../../../toolkit/notFound";
import React from "react";
import {
  ServiceCallerProps,
  serviceCaller,
  withLoginRedirect,
} from "../../composition";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

function Academy(props: ServiceCallerProps) {
  const enableAcademy = get(props, `config.enableAcademy`, false);
  let isLoading = true;

  if (props.config !== null) {
    isLoading = false;
  }

  return (
    <ProtectedRoute>
      <Fragment>
      {!isLoading && !enableAcademy && <NotFoundPage />}
      {enableAcademy && (
        <main>
          <Helmet title="Academy" />
          <Layout>
            <AcademyComponent />
          </Layout>
        </main>
      )}
      </Fragment>
    </ProtectedRoute>
  );
}

export default serviceCaller(withLoginRedirect(Academy));
